@if (isEditEnabled){
  <input class="edit-mode" (keydown.enter)="changeTitle()" (keydown.escape)="cancelChange()" [(ngModel)]="title" type="text"/>
} @else {
  <span class="view-mode">
    {{ chatbotTitle | slice:0:45}}
  </span>
}
